import {
  Autocomplete as MuiAutoComplete,
  AutocompleteProps as MuiAutocompleteProps,
  createTheme,
  ThemeProvider,
} from '@mui/material'

export interface AutocompleteProps extends Omit<MuiAutocompleteProps<any, any, any, any, any>, ''> {
  name: string
}

export const Autocomplete = ({ name, ...rest }: AutocompleteProps) => {
  const theme = createTheme({
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            paddingTop: '8px',
          },
        },
      },
    },
  })
  return (
    <ThemeProvider theme={theme}>
      <MuiAutoComplete id={name} {...rest} />
    </ThemeProvider>
  )
}
